import { ReactComponent as LogoLoggi } from 'assets/logo-loggi.svg';
import React from 'react';
import { blue } from 'theme/colors';

export default function LoggiLogo() {
  return <LogoLoggi height="24px" color={blue[500]} />;
}
